module.exports = __webpack_public_path__ + "static/AvenirNext-Light-7200ae55eef45f86d627fde19c521072.woff";